// extracted by mini-css-extract-plugin
export var formContainer = "_ik-0";
export var message = "_ik-1";